import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';

/**
 * Shown when a valid ticket has no name yet. No close button: the countdown
 * under Submit is how long the visitor has before the kiosk resets.
 */
function UsernameModal({
  show,
  name,
  setName,
  nameErr,
  setNameErr,
  onSubmit,
  loading = false,
  seconds = 90,
}) {
  const [left, setLeft] = useState(seconds);

  useEffect(() => {
    if (!show) return undefined;
    const total = Math.max(0, seconds);
    const started = Date.now();
    setLeft(total);
    const timer = window.setInterval(() => {
      const elapsed = Math.floor((Date.now() - started) / 1000);
      setLeft(Math.max(0, total - elapsed));
    }, 250);
    return () => window.clearInterval(timer);
  }, [show, seconds]);

  const minutes = String(Math.floor(left / 60)).padStart(2, '0');
  const remain = String(left % 60).padStart(2, '0');

  return (
    <Modal
      show={show}
      onHide={() => {}}
      backdrop="static"
      keyboard={false}
      centered
      scrollable={false}
      className="usernameModal"
    >
      <Modal.Body>
        {loading ? (
          <div className="usernameModal__loader" role="status" aria-live="polite">
            <span className="usernameModal__spinner" aria-hidden="true" />
            <span className="usernameModal__loaderText">Saving your name…</span>
          </div>
        ) : null}
        <form
          className="usernameModal__form"
          onSubmit={(event) => {
            event.preventDefault();
            if (!loading) onSubmit();
          }}
        >
          <h2 className="usernameModal__title">
            It seems you haven’t entered
            <br />
            your name yet
          </h2>
          <p className="usernameModal__copy">
            Your name will appear on the station displays you interacted with.
          </p>

          <label htmlFor="monster-username" className="usernameModal__label">
            Your name
          </label>
          <input
            id="monster-username"
            type="text"
            name="name"
            value={name}
            disabled={loading}
            autoFocus
            autoComplete="off"
            placeholder="Enter your name"
            className="usernameModal__input"
            onChange={(event) => {
              setName(event.target.value);
              if (event.target.value.trim()) setNameErr('');
            }}
          />
          {nameErr ? (
            <p className="usernameModal__error" role="alert">
              {nameErr}
            </p>
          ) : null}

          <button
            type="submit"
            className="usernameModal__button"
            disabled={loading}
            aria-busy={loading}
          >
            Submit
          </button>
          <p className="usernameModal__timer" aria-live="polite">
            This session will close automatically in {minutes}:{remain} seconds.
          </p>
        </form>
      </Modal.Body>
    </Modal>
  );
}

export default UsernameModal;
